module.exports = __webpack_public_path__ + "img/qsp.63f2ccb5.svg";